//NOTE TO DEVS - keep these alphabetical please 
var ICON_NAME_MAP = {
  accident: '21',
  add: 'e903',
  'accommodation-request': 'e966',
  'add-date': 'e901',
  'add-link': 'e97e',
  'add-link-slash': 'e97d',
  'add-something': 'e902',
  'align-center': 'e978',
  'align-left': 'e97a',
  'align-justify': 'e979',
  'align-right': 'e97b',
  'analytics-solid': 'e90f',
  'angle-double-left': '22',
  'angle-double-right': '23',
  'arrow-circle-down': 'e904',
  'arrow-circle-left': '24',
  'arrow-circle-right': '25',
  'arrow-circle-up': 'e905',
  'arrow-down': 'e910',
  'arrow-left': 'e911',
  'arrow-right': 'e912',
  'arrow-up': 'e913',
  backward: '26',
  badge: 'e95e',
  'bars-solid': 'e92e',
  'basic-services': 'e93d',
  billing: '27',
  bold: 'e977',
  'building-outline': 'e92f',
  'building-solid': 'e914',
  'calculator-ruler': 'e941',
  calendar: '28',
  'calendar-marked-dates': 'e959',
  'calendar-with-cake': 'e95a',
  'caret-down': '29',
  'caret-left': '2a',
  'caret-right': '2b',
  'caret-up': '2c',
  'charitable-work': 'e96e',
  'checklist-person': 'e942',
  'chevron-circle-down': '2d',
  'chevron-circle-left': '2e',
  'chevron-circle-right': '2f',
  'chevron-circle-up': '30',
  'chevron-down-solid': 'e937',
  'chevron-left-solid': 'e938',
  'chevron-right-solid': 'e939',
  'chevron-up-solid': 'e93a',
  'check-circle': 'f05d',
  'circle-closed': 'e906',
  'circle-open': 'e907',
  claims: '31',
  'clipboard-clock': 'e945',
  clock: '32',
  clone: 'e908',
  close: '33',
  'close-circle': 'f05c',
  'close-thin': 'e950',
  code: 'e97c',
  condition: 'e967',
  contact: 'e968',
  coverage: '34',
  'covered-services': 'e98a',
  'critical-illness': '35',
  'deductibles-and-coinsurance': 'e989',
  'dentist-chair': 'e957',
  'delete-from-queue': 'e909',
  documents: '36',
  'document-arrows': 'e949',
  'document-checkmark': 'e946',
  'document-magnify': 'e94b',
  'document-upload': 'e952',
  'dollar-sign-arrows': 'e948',
  download: '37',
  drill: 'e98e',
  edit: 'e90a',
  employees: '38',
  eoi: 'e900',
  envelope: 'e971',
  error: '39',
  'exchange-alt-solid': 'e94e',
  'eye-closed': '3a',
  'eye-open': '3b',
  facebook: 'e936',
  'facebook-square-brands': 'e95b',
  'family-care': 'e961',
  female: '3c',
  'file-confirm': 'e955',
  'file-chart-line-regular': 'e916',
  'file-chart-line-solid': 'e917',
  'file-excel-regular': 'e925',
  'file-import-solid': 'e92a',
  'file-new-claim-leave': 'e953',
  'file-overwrite': 'e92d',
  'file-regular': 'e918',
  'file-tooth': 'e956',
  'file-word-regular': 'e926',
  'folder-open-solid': 'e923',
  'folder-solid': 'e919',
  'folder-tree-solid': 'e91a',
  'folders-solid': 'e91b',
  filter: 'f0b0',
  'find-a-dentist': 'e988',
  forward: '3d',
  gear: '3e',
  'gear-check': 'e944',
  'grid-view': 'e90b',
  home: '3f',
  'hospital-indemnity': '40',
  'important-message': 'e96c',
  'id-card': 'e987',
  info: '41',
  'info-light': 'e990',
  instagram: 'e934',
  'instagram-square-brands': 'e95c',
  instruments: 'e98d',
  italic: 'e976',
  key: 'e972',
  life: '42',
  'life-ring-regular': 'e91c',
  link: 'e958',
  linkedin: 'e935',
  'linkedin-square-brands': 'e95d',
  'list-ol': 'e97f',
  'list-ul': 'e980',
  'list-view': 'e90c',
  lock: '43',
  'lock-open': 'e973',
  location: 'e94f',
  'long-arrow-down-regular': 'e91d',
  'long-arrow-left-regular': 'e91e',
  'long-arrow-right-regular': 'e91f',
  'long-arrow-up-regular': 'e920',
  'long-term-disability': '44',
  mail: 'e927',
  'major-services': 'e93e',
  maintenance: 'e96d',
  male: '45',
  'manage-preferences': 'e951',
  military: 'e962',
  mobile: 'e96f',
  'mobile-alt': 'e970',
  'mobile-alt-solid': 'e94d',
  money: 'e98f',
  network: 'e94a',
  'non-smoker': 'e921',
  'one': 'e981',
  'ortho-services': 'e93c',
  other: 'e963',
  'out-arrow': 'e986',
  'own-illness': 'e964',
  'paper-charts': 'e940',
  'paper-money': 'e943',
  parental: 'e960',
  'payment-card': 'e947',
  person: 'e94c',
  'person-with-tie': 'e974',
  'personal-info': 'e969',
  pdf: '46',
  phone: 'e928',
  pregnant: 'e965',
  'print-solid': 'e931',
  'preventive-services': 'e93b',
  profile: '47',
  question: '48',
  'quote-left': 'e982',
  'redo-alt-regular': 'e922',
  'residence-info': 'e96a',
  save: 'e92b',
  search: '49',
  'short-term-disability': '4a',
  strategy: 'e975',
  strikethrough: 'e985',
  subtract: 'e90d',
  success: '4b',
  'switch-employees': '4c',
  'switch-personal': '4d',
  'sync-solid': 'e930',
  trash: '4e',
  tooth: 'e93f',
  tooth1: 'e98b',
  toothpaste: 'e98c',
  twitter: 'e932',
  'twitter-square-brands': 'e932',
  two: 'e983',
  underline: 'e984',
  undo: 'e90e',
  upload: 'e924',
  usd: 'e929',
  'user-add': 'e92c',
  'view-request-status': 'e954',
  youtube: 'e933',
  'youtube-square-brands': 'e95f',
  'verify-identity': 'e96b',
  warning: '4f',
  'x-logo': 'e932'
};

export default ICON_NAME_MAP;
